import type ChartAction from './ChartAction';

/**
 * Столбик объёма за период [start, end): правая граница не входит,
 * для помесячной группировки end — первое число следующего месяца.
 */
class ChartBar {
  readonly start: Date;

  readonly end: Date;

  readonly value: number;

  readonly title: string;

  /** Клик по колонке периода; null — колонка не кликабельна */
  readonly action: ChartAction | null;

  constructor(start: Date, end: Date, value: number, title: string, action: ChartAction | null = null) {
    this.start = start;
    this.end = end;
    this.value = value;
    this.title = title;
    this.action = action;
  }
}

export default ChartBar;
